import { AccountSyncIcon } from './AccountSyncIcon';

/**
 * author: Michael Irigoyen
 * id 85F768C4-8659-414E-8C96-F2E90EB36971
 * name account-sync
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-sync.svg
 * tags
 * - Account / User 
 */
export const AccountCacheIcon = AccountSyncIcon;
export default AccountCacheIcon